export default __webpack_public_path__ + "static/media/azure.bf2db1e8.svg";